var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"link-wrapper"},[(_vm.$slots.default)?_c('a',{staticClass:"link-text",style:({
      'text-decoration': _vm.underline ? 'underline' : 'none',
      color: _vm.color
    }),on:{"click":_vm.goTo}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }